import { useState, useEffect } from 'react';
import useServerApi from 'hooks/useServerApi';

export function useGoogleCalendarSettings() {
    const [{ get }] = useServerApi();
    const [settingsData, setSettingsData] = useState({});
    const [isEnabled, setIsEnabled] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [initiated, setInitiated] = useState(false);

    const fetchSettings = async () => {
        const [success, res] = await get('/rest_endpoints/google_calendar_settings');
        if (success) {
            setSettingsData(res);
            setIsEnabled(res?.is_signed_in || false);
            setIsLoggedIn(res?.is_signed_in);
        }
        setInitiated(true);
    };

    useEffect(() => {
        fetchSettings();
    }, [get]);

    const refresh = () => {
        fetchSettings();
    };

    const getAuthUrl = async () => {
        const [success, res, err] = await get('/rest_endpoints/google_calendar_auth');
        if (err) {
            throw err;
        }
        return res?.url;
    };

    return { isEnabled, isLoggedIn, settingsData, setIsEnabled, refresh, getAuthUrl, initiated };
}